import { testResultsActionTypes } from './Constants';

const initialState = {
	loading: false,
	answers: [],
	resultsDetails: {},
	results: null,
	topicsAnswers: {},
	topicAnswersLoading: {},
};

export default function chapterDetailsReducer(state = initialState, action) {
	const { type, payload } = action;
	const { resultsDetails, answers, results, topicId, topicAnswers } = payload || {};

	switch (type) {
		case testResultsActionTypes.GET_RESULTS_DETAILS:
			return {
				...state,
				loading: true,
			};

		case testResultsActionTypes.GET_RESULTS_DETAILS_SUCCESS:
			return {
				...state,
				resultsDetails,
				loading: false,
			};

		case testResultsActionTypes.GET_RESULTS_SUCCESS:
			return {
				...state,
				results,
			};

		case testResultsActionTypes.GET_ANSWERS_SUCCESS:
			return {
				...state,
				answers,
			};

		case testResultsActionTypes.GET_TOPIC_ANSWERS:
			return {
				...state,
				topicAnswersLoading: {
					...state.topicAnswersLoading,
					[topicId]: true,
				},
			};

		case testResultsActionTypes.GET_TOPIC_ANSWERS_SUCCESS:
			return {
				...state,
				topicsAnswers: {
					...state.topicsAnswers,
					[topicId]: topicAnswers,
				},
				topicAnswersLoading: {},
			};

		case testResultsActionTypes.GET_TOPIC_ANSWERS_ERROR:
			return {
				...state,
				loading: false,
				topicAnswersLoading: {
					...state.topicAnswersLoading,
					[topicId]: false,
				},
			};

		case testResultsActionTypes.CLEAR_TEST_RESULTS:
			return {
				...state,
				...initialState,
			};

		default:
			return state;
	}
}
